import React from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

// Importa imágenes
import Image1 from '../../media/bazar.png';
import Image2 from '../../media/SOLY.jpg';
import Image3 from '../../media/marian.png';
import Image4 from '../../media/petfoot.png';
import Image5 from '../../media/planner.png';
import Image6 from '../../media/noCountryCinenema.jpg';
import Image7 from '../../media/inter.jpg';

const images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7];

// ----------------------------------------------------
// Styled Components
// ----------------------------------------------------
const StyledCarouselContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  position: relative;

  .carousel-root {
    .carousel {
      .slider-wrapper {
        .slider {
          .slide {
            background: none;
          }
        }
      }
    }
  }

  /* Estilos para las flechas de navegación */
  .carousel .control-arrow {
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    transition: background-color 0.3s ease, transform 0.3s ease;
    opacity: 0.8;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
      transform: scale(1.1);
      opacity: 1;
    }

    &.control-prev.control-arrow:before {
      border-right: 8px solid #333;
    }
    &.control-next.control-arrow:before {
      border-left: 8px solid #333;
    }
  }

  /* Estilos para los puntos de navegación (indicators) */
  .carousel .control-dots {
    bottom: 20px;
    
    .dot {
      background-color: #ffffff;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
      width: 10px;
      height: 10px;
      margin: 0 8px;
      opacity: 0.7;
      
      &.selected,
      &:hover {
        background-color: #007bff;
        opacity: 1;
        transform: scale(1.2);
      }
    }
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.5s ease;
`;

// ----------------------------------------------------
// Componente principal
// ----------------------------------------------------
const CarouselComponent = () => {
  return (
    <StyledCarouselContainer>
      <Carousel
        showArrows={true}
        infiniteLoop={true}
        autoPlay={true}
        showThumbs={false}
        showStatus={false}
      >
        {images.map((image, index) => (
          <div key={index}>
            <StyledImage src={image} alt={`Client project ${index + 1}`} />
          </div>
        ))}
      </Carousel>
    </StyledCarouselContainer>
  );
};

export default CarouselComponent;